import {
  InputAdornment,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

export const TableHeader = ({
  setGlobalFilter,
  headerText,
  isHeaderStyleChange = false,
  value,
}) => {
  const titleFontWeight = 600;
  const titleFontSize = "24px";

  return (
    <Stack
      sx={{
        borderRadius: "4px",
        padding: "16px",
        height: "62px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        bgcolor: "#fff",
      }}
    >
      <Typography
        sx={{
          fontWeight: titleFontWeight,
          fontSize: titleFontSize,
        }}
      >
        {headerText}
      </Typography>

      <OutlinedInput
        onChange={(e) => setGlobalFilter(e.target.value)}
        value={value}
        sx={{
          height: "36px",
          borderRadius: "10px",
          width: "200px",
          backgroundColor: isHeaderStyleChange ? "#313C4C" : "#F2F7FC",
          borderColor: isHeaderStyleChange && "#485364",

          "& input::placeholder": {
            color: isHeaderStyleChange && "#C4CFE4",
          },
          "& input": {
            p: "12.5px 14px 12.5px 4px !important",
            color: isHeaderStyleChange && "#C4CFE4",
          },
          "&:focus-within": {
            width: "400px",
          },
          transition: "width 0.5s",
        }}
        placeholder="Search here..."
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon size="small" />
          </InputAdornment>
        }
        endAdornment={
          value && (
            <InputAdornment
              sx={{ cursor: "pointer" }}
              position="end"
              onMouseDown={(e) => {
                e.preventDefault(); // Prevent default behavior
                setGlobalFilter("");
              }}
            >
              <CloseIcon size="large" />
            </InputAdornment>
          )
        }
      />
      <div></div>
    </Stack>
  );
};
